import { compose, get } from 'lodash/fp';
import {
    BusinessError,
    createAction,
    createAsyncActionTypes,
    createAsyncMetaSelectors,
    createReducer,
    isPciProxyInitialized,
} from '@mews/framework';
import {
    META_STATE_FAILED,
    META_STATE_STARTED,
    META_STATE_SUCCEEDED,
} from '@mews-commander/legacy-entities/src/constants';
import { initPciProxyScript } from '../../initPciProxyScript';

export default ({ prefix, moduleSelector }: $TSFixMe) => {
    const UPDATE_CARD_NUMBER_METADATA = prefix('UPDATE_CARD_NUMBER_METADATA');
    const UPDATE_CVV_METADATA = prefix('UPDATE_CVV_METADATA');
    const CLEAR_METADATA = prefix('CLEAR_METADATA');

    const PCI_PROXY_SCRIPT_INIT = prefix('PCI_PROXY_SCRIPT_INIT');
    const [PCI_PROXY_SCRIPT_INIT_STARTED, PCI_PROXY_SCRIPT_INIT_SUCCEEDED, PCI_PROXY_SCRIPT_INIT_FAILED] =
        createAsyncActionTypes(PCI_PROXY_SCRIPT_INIT);

    const init =
        ({ merchantId, cardNumberFieldId, cvvFieldId, fieldStyles, fontFaceStyles }: $TSFixMe) =>
        (dispatch: $TSFixMe, getState: $TSFixMe, { pciProxyService }: $TSFixMe) => {
            const state = getState();

            const hasScript = isPciProxyInitialized() && !isFetching(state);

            const promise = hasScript ? Promise.resolve() : dispatch(initPciProxyScript());
            promise.then(() => {
                pciProxyService.init({
                    merchantId,
                    cardNumberFieldId,
                    cvvFieldId,
                    styles: {
                        '*': fieldStyles,
                        '@font-face': {
                            '*': fontFaceStyles,
                        },
                    },
                });
            });

            return dispatch(createAction(PCI_PROXY_SCRIPT_INIT, promise));
        };

    const tearDown =
        () =>
        (dispatch: $TSFixMe, __: $TSFixMe, { pciProxyService }: $TSFixMe) => {
            pciProxyService.reset();
            dispatch(clearMetadata());
        };

    const updateCardNumberMetadata = (metadata: $TSFixMe) => createAction(UPDATE_CARD_NUMBER_METADATA, metadata);
    const updateCvvMetadata = (metadata: $TSFixMe) => createAction(UPDATE_CVV_METADATA, metadata);
    const clearMetadata = () => createAction(CLEAR_METADATA);

    const tokenizeCard =
        () =>
        (_: $TSFixMe, __: $TSFixMe, { pciProxyService }: $TSFixMe) =>
            pciProxyService
                .tokenize()
                .catch(({ error }: $TSFixMe) => {
                    throw new BusinessError(error);
                })
                .then(({ transactionId }: $TSFixMe) => transactionId);

    const reducer = createReducer(
        { ...META_STATE_SUCCEEDED, scriptLoaded: false },
        {
            // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
            [UPDATE_CARD_NUMBER_METADATA]: (state, payload) => ({
                ...state,

                cardNumber: {
                    ...state.cardNumber,
                    ...payload,
                },
            }),
            // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
            [UPDATE_CVV_METADATA]: (state, payload) => ({
                ...state,

                cvv: {
                    ...state.cvv,
                    ...payload,
                },
            }),
            [CLEAR_METADATA]: (state: $TSFixMe) => ({
                ...state,
                cardNumber: {},
                cvv: {},
            }),
            [PCI_PROXY_SCRIPT_INIT_STARTED]: (state: $TSFixMe) => ({
                ...state,
                ...META_STATE_STARTED,
            }),
            [PCI_PROXY_SCRIPT_INIT_SUCCEEDED]: (state: $TSFixMe) => ({
                ...state,
                ...META_STATE_SUCCEEDED,
                scriptLoaded: true,
            }),
            [PCI_PROXY_SCRIPT_INIT_FAILED]: (state: $TSFixMe) => ({
                ...state,
                ...META_STATE_FAILED,
            }),
        }
    );

    const getCardNumberMetadata = compose(get('cardNumber'), moduleSelector);
    const getCvvMetadata = compose(get('cvv'), moduleSelector);

    const getMeta = compose(get('meta'), moduleSelector);
    const [isFetching, hasFailed] = createAsyncMetaSelectors(getMeta);

    return {
        actions: {
            init,
            tearDown,
            updateCardNumberMetadata,
            updateCvvMetadata,
            tokenizeCard,
        },
        reducer,
        selectors: {
            getCardNumberMetadata,
            getCvvMetadata,
            isFetching,
            hasFailed,
        },
    };
};
